import { render, staticRenderFns } from "./ResolveIncidents.vue?vue&type=template&id=0598e0f4&"
import script from "./ResolveIncidents.vue?vue&type=script&lang=js&"
export * from "./ResolveIncidents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports